var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.796,
    cy: 0.466,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#387f75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c403b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107451",
    "data-name": "Group 107451",
    transform: "translate(-20 -287)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3799",
    "data-name": "Ellipse 3799",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(20 287)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_107450",
    "data-name": "Group 107450",
    transform: "translate(31.005 296.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106357",
    "data-name": "Path 106357",
    d: "M754.063,721.681l2.583-5.351-7.367-14.808h-5.245Z",
    transform: "translate(-743.773 -698.464)",
    fill: "#fefcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104747_-_Outline",
    "data-name": "Path 104747 - Outline",
    d: "M753.519,721.71l-10.292-20.688h5.606l.045.09,7.4,14.879-.034.071Zm-9.771-20.364,9.766,19.63,2.405-4.983-7.287-14.647Z",
    transform: "translate(-743.227 -698.125)",
    fill: "#fefcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106358",
    "data-name": "Path 106358",
    d: "M987.193,650.058c.832-3.247,4.736-5.771,5.509-5.686-2.872-1.406-4.754-3.243-5.509-5.568a9.054,9.054,0,0,1-5.627,5.627C984.306,644.472,986.006,646.72,987.193,650.058Z",
    transform: "translate(-971.563 -638.317)",
    fill: "#fefcfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104749_-_Outline",
    "data-name": "Path 104749 - Outline",
    d: "M985.349,649.593l-.177-.5c-1.327-3.73-3.068-5.484-5.478-5.52l-.89-.013.838-.3a8.873,8.873,0,0,0,5.531-5.533l.163-.428.142.436c.722,2.223,2.548,4.064,5.427,5.473l.831.407-.919-.1h-.023a6.39,6.39,0,0,0-2.643,1.606,8.587,8.587,0,0,0-2.669,3.961Zm-4.955-6.282a4.514,4.514,0,0,1,1.24.384,5.267,5.267,0,0,1,1.576,1.186,11.108,11.108,0,0,1,2.1,3.652,7.382,7.382,0,0,1,.962-1.822,11.308,11.308,0,0,1,3.339-3.059,5.134,5.134,0,0,1,.74-.361,12.9,12.9,0,0,1-3.179-2.262,8.14,8.14,0,0,1-1.855-2.787,9.874,9.874,0,0,1-1.97,3.054A9.091,9.091,0,0,1,980.394,643.311Z",
    transform: "translate(-969.693 -637.3)",
    fill: "#fefcfe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiLogo);
export default __webpack_public_path__ + "static/media/visionai_logo.2322f3d16936c4517cc0fd5126bc7025.svg";
export { ForwardRef as ReactComponent };